import type { ButtonProps } from "@chakra-ui/react";
import React, { Suspense } from "react";
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils";

export type Props = CMSPageProps & {
  title: string;
  link: string;
  backgroundColor?: string;
  buttonProps?: ButtonProps;
  isLoading?: boolean;
  discount?: string;
  membershipId?: string;
  customOnClickHandler?: (e) => void;
  isPrimaryStyle?: boolean;
};

const Button = React.lazy(() =>
  import("./Button").then((mod) => ({ default: mod.DeprecatedChakraButton }))
);
const LinkCta = React.lazy(() =>
  import("./LinkCta").then((mod) => ({ default: mod.LinkCta }))
);

export const DeprecatedChakraButtonCta: React.FC<Props> = (props) => {
  const { link } = props;

  const showCtaAsButton = link === "chatbot" || link === "atb";

  return (
    <Suspense>
      {showCtaAsButton ? <Button {...props} /> : <LinkCta {...props} />}
    </Suspense>
  );
};
